"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        '&:not(:last-child)': {
            borderBottom: `1px solid ${theme.grey6}`
        }
    },
    header: {
        display: 'flex',
        width: '100%',
        padding: '10px 7px',
        alignItems: 'center',
        outline: 'none',
        color: theme.grey1,
        '&[disabled]': {
            cursor: 'default',
            color: theme.grey3
        }
    },
    icon: {
        width: 24,
        height: 24,
        flexShrink: 0,
        marginRight: 7,
        color: 'currentColor',
        '& > svg': {
            display: 'block',
            width: '100%',
            height: '100%'
        }
    },
    name: {
        flexGrow: 1,
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '18px',
        marginRight: 7,
        color: 'currentColor',
        textTransform: 'capitalize'
    },
    traceCount: {
        textAlign: 'right',
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '18px',
        marginRight: 3,
        flexShrink: 0,
        color: 'currentColor'
    },
    toggleIcon: {
        width: 19,
        height: 19,
        color: 'currentColor',
        flexShrink: 0
    },
    items: {
        paddingLeft: 7,
        paddingRight: 7,
        transition: 'opacity 100ms linear 50ms',
        opacity: 1,
        '&[hidden]': {
            opacity: 0
        }
    }
});
//# sourceMappingURL=stage.style.js.map